<template>
<div class="main-header-page">
	<nav class="modern-breadcrumb" aria-label="Navegación">
		<button type="button" class="configuration-link" title="Abrir configuración" @click="openConfiguration">
			<v-icon>settings</v-icon>
			<span>Configuración</span>
		</button>
		<span class="configuration-separator"></span>
		<button v-if="breadcrumbs.length > 2" type="button" class="back-link" @click="goBack">
			<v-icon color="white">arrow_back</v-icon>
			<span>Volver</span>
		</button>
		<span v-if="breadcrumbs.length > 2" class="back-separator"></span>
		<button type="button" class="home-link" title="Ir a proyectos" @click="openHome">
			<v-icon>home</v-icon>
			<span>Inicio</span>
		</button>
		<template v-for="(item, index) in visibleBreadcrumbs">
			<template v-if="index > 0">
				<v-icon :key="`divider-${item.title}-${index}`" class="breadcrumb-divider">chevron_right</v-icon>
				<span
					v-if="index === visibleBreadcrumbs.length - 1"
					:key="`current-${item.title}-${index}`"
					class="breadcrumb-current"
					aria-current="page"
				>{{ item.title }}</span>
				<span
					v-else-if="!item.name"
					:key="`context-${item.title}-${index}`"
					class="breadcrumb-context"
				>{{ item.title }}</span>
				<button
					v-else
					:key="`link-${item.title}-${index}`"
					type="button"
					class="breadcrumb-link"
					@click="openLink(item)"
				>{{ item.title }}</button>
			</template>
		</template>
	</nav>
	<div class="header-page-actions"
		v-if="toShow">
		<v-btn
			v-if="exportToPdf"
			@click.prevent="downloadDispatch"
			class="header-page-download-document primary mr-2">
			<v-icon size="19">picture_as_pdf</v-icon>
		</v-btn>
		<v-btn
			v-if="showExcel"
			class="header-page-download-document primary"
			v-on:click="downloadDocument">
			<v-icon size="19">grid_on</v-icon>
		</v-btn>
		<v-btn
			v-if="showClean"
			v-on:click="cleanFilter">Limpiar</v-btn>
	</div>
	<div class="header-page-actions translate"
		v-if="quotation || sale">
		<v-btn
			flat
			class="header-page-download-document"
			v-on:click="downloadDocument">
			<v-icon size="19">file_download</v-icon>
		</v-btn>
		<v-btn
			flat
			class="header-page-download-document"
			v-on:click="print">
			<v-icon size="19">print</v-icon>
		</v-btn>
	</div>
</div>
</template>

<script>
function data() {
	return {
		breadcrumbs: [],
	};
}

function cleanFilter() {
	this.$emit('clean-product-filter');
}

function columnsToExport() {
	const columnsSelected = this.columns.filter(column => column.visible && !column.flagVisible);
	/* eslint-disable arrow-parens */
	const newColumns = columnsSelected.map(col => {
		const newCol = Object.assign({}, col);
		delete newCol.id;
		delete newCol.visible;
		delete newCol.checked;
		return newCol;
	});
	return newColumns;
}
function dataToExport() {
	let tableDataToExport = [];
	const columnsSelected = this.columns.filter(column => column.visible && !column.flagVisible);
	const columnsValues = columnsSelected.map(colVal => {
		const newColVal = Object.assign({}, colVal);
		return newColVal.value;
	});
	if (this.rows.length > 0) {
		tableDataToExport = this.rows.map(dataExport => {
			const newData = Object.assign({}, dataExport);
			const keysData = Object.keys(dataExport);
			keysData.forEach(keyData => {
				if (columnsValues.every(keyCol => keyCol !== keyData)) {
					delete newData[keyData];
				}
			});
			return newData;
		});
	}
	return tableDataToExport;
}

function visibleBreadcrumbs() {
	const meaningfulItems = this.breadcrumbs.filter((item, index) => (
		index === 0 || !/^\d+$/.test(String(item.title || '').trim())
	));
	if (meaningfulItems.length <= 2) return meaningfulItems;
	return [meaningfulItems[0], meaningfulItems[meaningfulItems.length - 1]];
}

function downloadDispatch() {
	this.$emit('download-dispatch');
}

function downloadDocument() {
	this.exportTable(this.columnsToExport, this.dataToExport, this.name);
}

function openLink({ name }) {
	this.goTo(name, { params: this.$route.params });
}

function goBack() {
	const { returnTo, returnParams } = this.$route.query;
	if (returnTo && this.$route.name === 'page-user') {
		let params = {};
		try {
			params = returnParams ? JSON.parse(returnParams) : {};
		} catch (error) {
			params = {};
		}
		this.goTo(returnTo, { params, query: {} });
		return;
	}
	const previousRoute = this.breadcrumbs
		.slice(0, -1)
		.reverse()
		.find(item => item.name);
	if (previousRoute) {
		this.openLink(previousRoute);
	}
}

function print() {
	window.print();
}

function routeHandler(newVal) {
	this.breadcrumbs = newVal.matched.reduce((acum, route) => {
		const routesToAcum = [];
		const keys = route.regex.keys;
		if (keys.length > 0) {
			keys.forEach(key => {
				const name = this.$route.params[key.name];
				if (name) {
					const indexAcum = acum.findIndex(ac => ac.title === name);
					if (indexAcum === -1) {
						routesToAcum.push({ title: name });
					}
				}
			});
		}
		routesToAcum.push({ name: route.name, title: route.meta.title });
		return acum.concat(routesToAcum);
	}, []);
}

function openHome() {
	this.goTo('page-project');
}

function openConfiguration() {
	this.goTo('page-config-dealers');
}

export default {
	name: 'header-page',
	computed: {
		columnsToExport,
		dataToExport,
		visibleBreadcrumbs,
	},
	data,
	methods: {
		cleanFilter,
		downloadDispatch,
		downloadDocument,
		goBack,
		openLink,
		openHome,
		openConfiguration,
		print,
	},
	props: {
		columns: {
			type: Array,
		},
		exportToPdf: {
			default: false,
			type: Boolean,
		},
		name: {
			type: String,
		},
		rows: {
			type: Array,
		},
		showClean: {
			default: true,
			type: Boolean,
		},
		showExcel: {
			default: true,
			type: Boolean,
		},
		title: {
			type: String,
			required: true,
		},
		toShow: {
			default: false,
			type: Boolean,
		},
		quotation: {
			default: false,
			type: Boolean,
		},
		sale: {
			default: false,
			type: Boolean,
		},
	},
	watch: {
		$route: {
			handler: routeHandler,
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.main-header-page {
	@include flex-between;
	background-color: rgba(255, 255, 255, .98);
	border-bottom: 1px solid #E2EAE6;
	flex-wrap: wrap;
	min-height: 48px;
	padding: 0 52px;
	width: 100%;

	.modern-breadcrumb {
		align-items: center;
		display: flex;
		flex-wrap: wrap;
		gap: 4px;
		min-height: 48px;
	}
	.home-link,
	.breadcrumb-link,
	.back-link,
	.configuration-link {
		align-items: center;
		background: transparent;
		border: 0;
		border-radius: 6px;
		color: #1A4338;
		cursor: pointer;
		display: inline-flex;
		font-size: 12px;
		font-weight: 600;
		height: 32px;
		outline: none;
		padding: 0 9px;
		transition: background .16s ease, color .16s ease;
		&:hover, &:focus { background: #EEF5F2; }
	}
	.configuration-link {
		background: #EAF3EF;
		border: 1px solid #C8DDD5;
		color: #1A4338 !important;
		font-weight: 700;
		margin-right: 5px;
		opacity: 1 !important;
		padding: 0 10px;
		.icon { color: #1A4338 !important; font-size: 17px; margin-right: 6px; opacity: 1 !important; }
		span { color: #1A4338 !important; opacity: 1 !important; }
		&:hover, &:focus {
			background: #DCEAE4;
			border-color: #AFCBC0;
			color: #12372E !important;
		}
	}
	.configuration-separator { background: #DCE7E2; height: 18px; margin: 0 5px 0 0; width: 1px; }
	.back-link {
		background: transparent;
		color: #40564E;
		padding: 0 9px 0 7px;
		.icon { color: #587067 !important; font-size: 17px; margin-right: 4px; }
		&:hover, &:focus { background: #F0F4F2; color: #1A4338; }
	}
	.back-separator { background: #DCE7E2; height: 18px; margin: 0 4px; width: 1px; }
	.home-link {
		background: transparent;
		color: #40564E;
		padding: 0 8px 0 6px;
		.icon { color: #71847C; font-size: 18px; margin-right: 5px; }
	}
	.breadcrumb-divider { color: #a8b4c0; font-size: 16px; }
	.breadcrumb-context {
		background: #EEF5F2;
		border: 1px solid #C8DDD5;
		border-radius: 999px;
		color: #1A4338;
		font-family: monospace;
		font-size: 11px;
		font-weight: 600;
		padding: 5px 10px;
	}
	.breadcrumb-current {
		color: #2D413A;
		font-size: 12px;
		font-weight: 700;
		max-width: 240px;
		overflow: hidden;
		padding: 5px 7px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.header-page-title {
		color: map-get($colors, paginationText);
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, large);
		margin: 0px;
	}
	.header-page-actions {
		@include flex-between;
		margin-left: 40px;
		.btn {
			@include txt-config(open-semibold, small10);
			background-color: map-get($colors, orange-btn);
			border-radius: 5px;
			color: white;
			height: 25px;
			min-width: 58px;
			text-transform: capitalize;
		}
		.header-page-download-document {
			@include flex-center;
			min-width: 25px;
			margin: 0px;
		}
	}
}

@media (max-width: 700px) {
	.main-header-page {
		min-height: 44px;
		padding: 0 14px;
	}
	.configuration-link span { display: none; }
	.main-header-page .configuration-link { padding: 0 7px; }
	.main-header-page .configuration-link .icon { margin-right: 0; }
}
.translate {
	transform: translateX(-200px);
	display: grid !important;
	grid-template-columns: 20px 20px;
	grid-column-gap: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/header-page.vue